import { forecastChartConfig } from '../config/forecastCharts.config';
import {
  generateDetailedChart,
  generate7DayChart,
  generate15DayChart,
  generateMetricChart,
  generateWindSpeedChart,
} from './forecastChartGenerators.utils';

/**
 * Finds the settings used to load and build the selected chart.
 * Missing or unknown IDs open the 5-day detailed forecast, the page's first tab.
 */
export const getForecastChartConfig = (chartId) => {
  return forecastChartConfig.find(({ id }) => id === chartId) ?? forecastChartConfig[0];
};

/**
 * Turns one forecast response into the data and options needed by the selected page chart.
 * Empty responses return no chart so BaseChart can show its no-data message.
 */
export const buildForecastChart = (forecast, chartConfig) => {
  if (!Array.isArray(forecast) || forecast.length === 0) return undefined;

  switch (chartConfig.id) {
    case 'detailedForecast':
      return generateDetailedChart(forecast);
    case 'hourlyForecast':
      // Preserve the page's existing weather-icon and wind-arrow spacing.
      return generate7DayChart(forecast, {}, 4, 4);
    case 'day15Forecast':
      return generate15DayChart(forecast);
    case 'windSpeed':
      return generateWindSpeedChart(forecast, chartConfig);
    default:
      return generateMetricChart(forecast, chartConfig);
  }
};
